import {
  FiHome,
  FiEdit3,
  FiBriefcase,
  FiCompass,
  FiHeart,
  FiFolder,
  FiUsers,
  FiUser,
  FiKey,
  FiTrendingUp,
  FiGrid,
  FiBookOpen,
  FiCreditCard,
  FiLayers,
  FiFileText,
  FiGift,
  FiAward,
  FiCalendar,
  FiMail,
  FiShoppingBag,
  FiHelpCircle,
  FiZap,
  FiActivity,
} from "react-icons/fi";

const createItem = (item) => ({
  ...item,
  activePrefixes: item.activePrefixes ?? [item.to],
});

export const CUSTOMER_PANEL_HOME = "/customer/workspace";

export const customerSidebarSections = [
  {
    id: "overview",
    title: "Overview",
    items: [
      {
        to: "/customer/workspace",
        label: "Dashboard",
        icon: FiHome,
        activePrefixes: ["/customer/workspace", "/customer/dashboard"],
      },
      {
        to: "/customer/myspace",
        label: "MySpace",
        icon: FiFolder,
        activePrefixes: ["/customer/myspace"],
      },
    ],
  },
  {
    id: "create-content",
    title: "Create Content",
    items: [
      {
        to: "/post/add-post",
        label: "Create Post",
        icon: FiEdit3,
        activePrefixes: ["/post/add-post"],
      },
      {
        to: "/add-property",
        label: "Create Property",
        icon: FiBriefcase,
        activePrefixes: ["/add-property", "/property/add-property"],
      },
    ],
  },
  {
    id: "marketplace-services",
    title: "Marketplace & Services",
    items: [
      {
        to: "/customer/services",
        label: "All Services Directory",
        icon: FiLayers,
        activePrefixes: ["/customer/services"],
      },
      {
        to: "/interiordesign",
        label: "Interior Design",
        icon: FiCompass,
        activePrefixes: ["/interiordesign"],
      },
      {
        to: "/property-services",
        label: "Integrator Services",
        icon: FiGrid,
        activePrefixes: ["/property-services", "/property-service"],
      },
      {
        to: "/customer/bazaar",
        label: "Local Bazaar",
        icon: FiShoppingBag,
        activePrefixes: ["/customer/bazaar"],
      },
      {
        to: "/customer/healthians",
        label: "Care Leads (Healthians)",
        icon: FiActivity,
        activePrefixes: ["/customer/healthians"],
      },
    ],
  },
  {
    id: "engagement",
    title: "Community & Connections",
    items: [
      {
        to: "/customer/leads",
        label: "Customer Leads",
        icon: FiFileText,
        activePrefixes: ["/customer/leads"],
      },
      {
        to: "/customer/communities",
        label: "Communities",
        icon: FiUsers,
        activePrefixes: ["/customer/communities"],
      },
      {
        to: "/customer/invitations",
        label: "Invitations",
        icon: FiMail,
        activePrefixes: ["/customer/invitations"],
      },
      {
        to: "/customer/reminders",
        label: "Meeting Reminders",
        icon: FiCalendar,
        activePrefixes: ["/customer/reminders"],
      },
    ],
  },
  {
    id: "growth-rewards",
    title: "Rewards & Member Hub",
    items: [
      {
        to: "/customer/profile",
        label: "Profile & Rewards",
        icon: FiUser,
        activePrefixes: ["/customer/profile"],
      },
      {
        to: "/customer/rewards",
        label: "Rewards & Points",
        icon: FiGift,
        activePrefixes: ["/customer/rewards"],
      },
      {
        to: "/customer/brand-ambassador",
        label: "Brand Ambassador",
        icon: FiAward,
        activePrefixes: ["/customer/brand-ambassador"],
      },
      {
        to: "/customer/help",
        label: "Help & Support",
        icon: FiHelpCircle,
        activePrefixes: ["/customer/help"],
      },
    ],
  },
  {
    id: "tools",
    title: "Business Tools",
    items: [
      {
        to: "/customer/tools",
        label: "Tools Hub",
        icon: FiGrid,
        activePrefixes: ["/customer/tools"],
      },
      {
        to: "/customer/tools/khatabook",
        label: "Khatabook",
        icon: FiBookOpen,
        activePrefixes: ["/customer/tools/khatabook"],
      },
      {
        to: "/customer/tools/cashbook",
        label: "Cashbook",
        icon: FiCreditCard,
        activePrefixes: ["/customer/tools/cashbook"],
      },
      {
        to: "/customer/tools/projects",
        label: "Project Ledger",
        icon: FiLayers,
        activePrefixes: ["/customer/tools/projects"],
      },
      {
        to: "/customer/tools/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/customer/tools/leases", "/customer/leases"],
      },
    ],
  },
  {
    id: "shared",
    title: "Marketplace & Community",
    items: [
      {
        to: "/customer/properties",
        label: "Browse Properties",
        icon: FiBriefcase,
        activePrefixes: ["/customer/properties"],
      },
      {
        to: "/customer/posts",
        label: "Community Posts",
        icon: FiEdit3,
        activePrefixes: ["/customer/posts"],
      },
      {
        to: "/customer/promotions",
        label: "Featured Promotions",
        icon: FiTrendingUp,
        activePrefixes: ["/customer/promotions"],
      },
      {
        to: "/customer/shared-leads",
        label: "Shared Leads",
        icon: FiCompass,
        activePrefixes: ["/customer/shared-leads"],
      },
    ],
  },
  {
    id: "myspace",
    title: "Saved & Personal Space",
    items: [
      {
        to: "/customer/saved",
        label: "Saved Properties",
        icon: FiHeart,
        activePrefixes: ["/customer/saved", "/customer/following"],
      },
      {
        to: "/customer/my-posts",
        label: "My Requirements",
        icon: FiEdit3,
        activePrefixes: ["/customer/my-posts"],
      },
      {
        to: "/customer/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/customer/leases"],
      },
      {
        to: "/customer/shared-with-me",
        label: "Shared with Me",
        icon: FiFolder,
        activePrefixes: ["/customer/shared-with-me"],
      },
    ],
  },
  {
    id: "people",
    title: "People",
    items: [
      {
        to: "/customer/network",
        label: "My Network",
        icon: FiUsers,
        activePrefixes: ["/customer/network"],
      },
      {
        to: "/customer/friends",
        label: "Customers & Friends",
        icon: FiUser,
        activePrefixes: ["/customer/friends"],
      },
      {
        to: "/customer/agents",
        label: "Agents & Associates",
        icon: FiUser,
        activePrefixes: ["/customer/agents"],
      },
    ],
  },
].map((section) => ({
  ...section,
  items: section.items.map(createItem),
}));

export const getCustomerPageTitle = (pathname) => {
  const allItems = customerSidebarSections.flatMap((s) => s.items);
  const found = allItems.find((item) =>
    item.activePrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  );
  return found?.label ?? "Customer Dashboard";
};

const customerNavigation = {
  sections: customerSidebarSections,
};

export default customerNavigation;
